module.exports = __webpack_public_path__ + "static/media/ic_hi_b2_fisdom.e0931c11.svg";